@if (rows().length > 0) {
  <div class="rep-list">
    @for (row of rows(); track row.id) {
      <sz-run-row
        [index]="row.index"
        [value]="row.value"
        [unit]="row.unit"
        [best]="row.best"
        [interactive]="interactive()"
        (edit)="runEdit.emit(row.id)"
        (remove)="runDelete.emit(row.id)" />
    }
  </div>
}
